import React from "react";
import "./Header.scss";
import Grid from "@mui/material/Grid";
import { Typography } from "@mui/material";

const Header = (props) => {
  const className = props.className
    ? `${props.className} instream-header-bar`
    : "instream-header-bar";

  let subTitleComponent;
  let titleClass = "full-title";
  if (props.subTitle) {
    subTitleComponent = <div className="sub-title">{props.subTitle}</div>;
    titleClass = "half-title";
  }

  /*  let color = "default-title-color";
  if (props.color === "primary") {
    color = "primary-title-color";
  }*/

  return (
    <Grid container spacing={3} className={className}>
      <Grid item xs={props.labelWidth ? props.labelWidth : 7} className="left-side">
        <Typography className={titleClass} variant={"h1"} component={"h1"}>
          {props.title}
        </Typography>
        {subTitleComponent}
      </Grid>
      <Grid item xs={props.labelWidth ? (12 - props.labelWidth) : 5} className="right-side">
        {props.children}
      </Grid>
    </Grid>
  );
};

export default Header;
